import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Jaga

  <span style="color:#85c1dc;">**FI:**</span>
  Jaa

  <span style="color:#85c1dc;">**RU:**</span>
  Поделись
*/
/* @__NO_SIDE_EFFECTS__ */
const m780 = msg(
  mf`Jaga`,
  mf`Jaa`,
  mf`Поделись`,
)

export { m780 as 'w.wishlist.button.share_mobile' }